export default __webpack_public_path__ + "static/CelAnimation-Blanket-ae169289ff346e26f68e9b35b5feae82.png";